import React, { useState } from 'react';

// Dina utbildningsscenarier med ikoner
const scenarios = [
  { 
    id: 'phishing', 
    name: 'Nätfiske (Ovanlig aktivitet)', 
    file: '/scenarios/PhisingMail.html',
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  },
  { 
    id: 'fildelning', 
    name: 'Säker Fildelning (OneDrive)', 
    file: '/scenarios/SakerFildelning2.0.html',
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
  },
  { 
    id: 'postnord', 
    name: 'PostNord SMS (Smishing)', 
    file: '/scenarios/PostNord-SMS-Scam.html',
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
  },
  { 
    id: 'nimblr', 
    name: 'Nimblr Utbildning', 
    file: '/scenarios/Nimblr.html',
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
  }
];

function App() {
  const [activeScenario, setActiveScenario] = useState(scenarios[0]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

// Ladda om iframen för att återställa scenariot
  const reloadScenario = () => {
    const iframe = document.getElementById('scenario-iframe');
    if (iframe && iframe.contentWindow) {
      // Använd inbyggd reload istället för att tilldela src till sig själv
      iframe.contentWindow.location.reload();
    }
  };

  return (
    <div className="flex h-screen bg-[#F4F7F6] font-sans overflow-hidden text-slate-800">
      
      {/* Ljus och modern Sidebar */}
      <aside 
        className={`transition-all duration-300 ease-in-out bg-white border-r border-slate-200 z-20 flex-shrink-0 overflow-hidden ${
          isSidebarOpen ? 'w-72' : 'w-0'
        }`}
      >
        {/* Låst inre bredd för att förhindra att innehållet "krossas" vid animering */}
        <div className="w-72 flex flex-col h-full">
          
          {/* Logotyp-sektion */}
          <div className="h-20 flex items-center px-6 border-b border-slate-100">
            <img 
              src="https://cdn.sanity.io/images/k3kwn7d7/production/f9859d91fdf6f1200458d94058d650e3e7bb2738-1500x633.png?rect=147,0,1206,633&w=1200&h=630" 
              alt="Education Logo" 
              className="h-10 object-contain"
            />
          </div>
          
          {/* Navigationsmeny */}
          <nav className="flex-1 overflow-y-auto py-6 px-3">
            <div className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3 px-3">
              Övningsscenarier
            </div>
            <ul className="space-y-1.5">
              {scenarios.map((scenario) => {
                const isActive = activeScenario.id === scenario.id;
                return (
                  <li key={scenario.id}>
                    <button
                      onClick={() => setActiveScenario(scenario)}
                      className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${
                        isActive
                          ? 'bg-slate-50 text-slate-900 shadow-sm ring-1 ring-slate-200 relative overflow-hidden'
                          : 'text-slate-500 hover:bg-slate-50 hover:text-slate-700'
                      }`}
                    >
                      {/* Vänster kantlinje för aktivt val */}
                      {isActive && (
                        <div className="absolute left-0 top-0 bottom-0 w-1 bg-slate-800 rounded-l-lg"></div>
                      )}
                      
                      <svg className={`w-5 h-5 ${isActive ? 'text-slate-800' : 'text-slate-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        {scenario.icon}
                      </svg>
                      <span className="font-medium text-sm">{scenario.name}</span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      </aside>

      {/* Main Content Area */}
      <main className="flex-1 flex flex-col relative h-full min-w-0">
        
        {/* Top Header */}
        <header className="h-20 bg-white/60 backdrop-blur-xl border-b border-slate-200/80 flex items-center justify-between px-6 z-10 sticky top-0">
          <div className="flex items-center gap-4">
            <button 
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              className="p-2 rounded-lg hover:bg-white border border-transparent hover:border-slate-200 hover:shadow-sm text-slate-500 hover:text-slate-800 transition-all focus:outline-none"
              title={isSidebarOpen ? "Dölj meny" : "Visa meny"}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            
            <div className="h-5 w-px bg-slate-300 hidden sm:block"></div>
            
            <h2 className="text-lg font-semibold text-slate-800 truncate">
              {activeScenario.name}
            </h2>
          </div>

          <button 
            onClick={reloadScenario}
            className="group flex items-center gap-2 px-4 py-2 bg-white hover:bg-slate-50 text-slate-700 rounded-lg text-sm font-medium transition-all border border-slate-200 shadow-sm hover:shadow"
          >
            <svg className="w-4 h-4 text-slate-500 transition-transform group-hover:rotate-180 duration-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            <span className="hidden sm:inline">Återställ vy</span>
          </button>
        </header>

        {/* Iframe Container */}
        <div className="flex-1 p-4 sm:p-6 lg:p-8 overflow-hidden flex flex-col">
          <div className="flex-1 relative rounded-xl overflow-hidden shadow-lg border border-slate-200/60 bg-white">
            <iframe
              id="scenario-iframe"
              title="Utbildningsscenario"
              src={activeScenario.file}
              className="absolute inset-0 w-full h-full border-0"
            />
          </div>
        </div>
        
      </main>
    </div>
  );
}

export default App;